import React from 'react';
import { computed, autorun, observable, toJS } from 'mobx';
import { Link } from 'react-router';
import _ from 'lodash';

export default class StationModel {
  id;
  identifier;
  name;
  longitude;
  latitude;
  elevation;
  description;
  // @observable meta_data;
  meta_data;
  data_source;
  @observable data_origin;
  @observable data_series;
  @observable monitoring;
  parameters;
  meta_data_template_id;
  // @observable meta_data_template_id;
  @observable tags = [];
  @observable images = [];

  store;

  // autoSave = true;

  saveHandler;

  constructor(store, station) {
    this.store = store;
    this.id = +station.id;
    this.identifier = station.identifier;
    this.folder_id = station.folder_id;
    this.name = station.name;
    this.longitude = station.longitude;
    this.latitude = station.latitude;
    this.elevation = station.elevation;
    this.description = station.description;
    this.location_id = station.location_id;
    this.station_type_id = station.station_type_id;
    this.meta_data = station.meta_data || [];
    this.data_source = station.data_source || null;
    this.data_origin = station.data_origin || [];
    this.data_series = station.data_series || [];
    this.monitoring = station.monitoring || [];
    this.parameters = station.parameters || [];
    this.meta_data_template_id = station.meta_data_template_id;
    this.tags = station.tags || [];
    this.images = station.images || [];

    // this.saveHandler = autorun(() => {
      // const json = this.asJson;

      // if (this.autoSave) {
        // // TODO
        // // console.log('TODO: save station', json);
        // this.store.transportLayer.saveStation(json);
      // }
    // });
  }

  @computed get asJson() {
    return {
      id: +this.id,
      identifier: this.identifier,
      folder_id: this.folder_id,
      name: this.name,
      longitude: this.longitude,
      latitude: this.latitude,
      elevation: this.elevation,
      description: this.description,
      location_id: this.location_id,
      station_type_id: this.station_type_id,
      meta_data: this.meta_data.map(item => _.pick(item, ['id', 'name', 'caption', 'description', 'flagged', 'seq', 'value'])) || [],
      data_source: this.data_source,
      data_origin: this.data_origin || [],
      data_series: this.data_series || [],
      monitoring: this.monitoring || [],
      parameters: this.parameters || [],
      meta_data_template_id: this.meta_data_template_id,
      tags: this.tags.map((item) => _.pick(item, ['id', 'name', 'description'])),
      images: this.images,
    };
  }

  // deprecated: use updateFromJson
  updateFieldFromJson(field, json) {
    const items = this[field];
    if (field && this[field]) {
      this[field].push(json);
    }
  }

  updateFromJson(json, field) {
    // if field is specified, update only that field and return. Unstable
    if (field) {
      if (this[field].replace) {
        this[field].replace(json || []);
        return;
      }

      this[field] = json || [];
      return;
    }

    // Object.keys(json).forEach(key => {
    //   if(!!json[key] || json[key] === 0) this[key] = json[key];
    // });

    if(!!json.id) this.id = +json.id;
    if(!!json.identifier) this.identifier = json.identifier;
    if(!!json.folder_id) this.folder_id = json.folder_id;
    if(!!json.name) this.name = json.name;
    if(!!json.longitude) this.longitude = json.longitude;
    if(!!json.latitude) this.latitude = json.latitude;
    if(!!json.elevation) this.elevation = json.elevation;
    if(!!json.description) this.description = json.description;
    if(!!json.meta_data) this.meta_data = json.meta_data || [];
    if(!!json.location_id) this.location_id = json.location_id;
    if(!!json.station_type_id) this.station_type_id = json.station_type_id;
    // this.meta_data.replace(json.meta_data || []);
    if(!!json.data_source)this.data_source = json.data_source || null;
    // this.data_origin = json.data_origin || [];
    if(!!json.parameters) this.parameters = json.parameters || [];
    if(!!json.meta_data_template_id) this.meta_data_template_id = json.meta_data_template_id;
    // this.tags = json.tags || [];
    if(!!json.tags) this.tags.replace(json.tags || []);
    if(!!json.images) this.images.replace(json.images || []);

  }

  // dispose() {
    // this.saveHandler();
  // }

  flattenDataOrigin(dataArray) {
    const data = dataArray || [];
    const stationId = this.id;

    const arr = [];

    data.forEach(dataOrigin => {
      arr.push({
        type: 'DATA_ORIGIN',
        level: 1,
        key: dataOrigin.id,
        slug: `station/${stationId}/data-origin`,

        id: dataOrigin.id,
        origin: dataOrigin.code,
        dop_code: null,
        parameter_name: null,
        parameter_unit_name: null,
        data_source: dataOrigin.data_source_name,
        timezone: dataOrigin.timezone,

        data: {
          id: dataOrigin.id,
          code: dataOrigin.code,
          timezone: dataOrigin.timezone,
          data_source_id: dataOrigin.data_source_id,
          data_source_name: dataOrigin.data_source_name,
        },
      });

      if (dataOrigin.data_origin_parameters) {
        dataOrigin.data_origin_parameters.forEach(dop => {
          arr.push({
            type: 'DATA_ORIGIN_PARAMETER',
            level: 2,
            key: `${dataOrigin.id}.${dop.id}`,
            // slug: `station/${stationId}/data-origin-parameter`,
            slug: null,
            parent_id: dataOrigin.id,


            id: dop.id,
            origin: null,
            dop_code: dop.code,
            parameter_name: dop.parameter_name,
            parameter_unit_name: dop.parameter_unit_name,
            data_source: null,
            timezone: null,

            data: {
              id: dop.id,
              data_origin_id: dop.data_origin_id,
              code: dop.code,
              parameter_id: dop.parameter_id,
              parameter_unit_id: dop.parameter_unit_id,
            },
          });
        });
      }
    });

    return arr;
  }

  @computed get dataOriginHier() {
    return this.flattenDataOrigin(this.data_origin);
  }

  flattenDataSeries(dataArray) {
    const stationId = this.id;
    const arr = [];

    dataArray.forEach(dataSeries => {
      const qcRulesLen = (dataSeries.qc_rules && dataSeries.qc_rules.length) || 0;
      arr.push({
        type: 'DATA_SERIES',
        level: 1,
        key: dataSeries.id,
        slug: `station/${stationId}/data-series`,
          // childSlug: `${dataSeries.id}/qc-rule`,

        id: dataSeries.id,
        // qc: null,
        qc: <Link to={`/station/${stationId}/data-series/${dataSeries.id}/qc-rule`}>
          QC <span className={'roundContainer'}>{qcRulesLen}</span>
        </Link>,
        name: `${dataSeries.name} (${dataSeries.id})`,
        unit: dataSeries.parameter_unit && dataSeries.parameter_unit.name,

        data: dataSeries,
      });
      if (dataSeries.qc_rules) {
        dataSeries.qc_rules.forEach(qcRule => {
          arr.push({
            type: 'QC_RULE',
            level: 2,
            key: `${dataSeries.id}.${qcRule.id}`,
            // slug: `${dataSeries.id}/qc-rule`,
            slug: null,
            parent_id: dataSeries.id,

            id: null,
            qc: qcRule.qc_type.name + ' - ' + qcRule.description,
            name: null,
            unit: null,

            data: qcRule,
          });
        });
      }
    });

    return arr;
  }

  @computed get dataSeriesHier() {
    return this.flattenDataSeries(this.data_series);
  }
}



// WEBPACK FOOTER //
// ./src/models/StationModel.js